import { Box, Card, Grid, Typography } from "@mui/material";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { appUrl, facebookClientId } from "../../common/api/config";
import facebookLogo from "../../common/assets/img/platform_logos/facebook.svg";
import Button from "../../common/components/Button";
import { SPACING } from "../../common/constants/spacing";
import { requestAccessTokenFromFacebook } from "../api/facebook";

const openFacebookOAuthPopup = () => {
  const redirectUri = `${appUrl}/facebook-oauth-callback`;

  const scope =
    "pages_show_list,pages_read_engagement,pages_manage_metadata,pages_read_user_content,pages_manage_posts,pages_manage_engagement,read_insights";
  const state = "facebook-oauth";
  const oauthUrl = `https://www.facebook.com/v21.0/dialog/oauth?client_id=${facebookClientId}&redirect_uri=${encodeURIComponent(
    redirectUri,
  )}&scope=${encodeURIComponent(scope)}&response_type=code&state=${state}`;

  const width = 500;
  const height = 600;
  const left = (window.innerWidth - width) / 2;
  const top = (window.innerHeight - height) / 2;

  window.open(
    oauthUrl,
    "FacebookOAuth",
    `width=${width},height=${height},top=${top},left=${left}`,
  );
};

export const LinkFacebookCard = ({ createSource }) => {
  const { t } = useTranslation("sources");

  useEffect(() => {
    const handleMessage = async (event) => {
      if (event.origin !== window.location.origin) return;

      if (event.data?.source === "facebook-oauth" && event.data.code) {
        const authCode = event.data.code;
        const tokenData = await requestAccessTokenFromFacebook(authCode);

        const source = {
          account_name: "Account Name",
          platform: "facebook",
          access_token: tokenData.access_token,
          refresh_token: tokenData.refresh_token,
        };
        try {
          await createSource(source);
        } catch (error) {
          console.error("Error creating data source:", error);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Grid size={{ xs: 12, md: 4 }}>
      <Card variant="outlined" sx={{ p: 3, height: "100%", mt: 1 }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <Box>
            <img
              src={facebookLogo}
              alt="Facebook Logo"
              style={{ height: "70px", objectFit: "contain", marginBottom: 10 }}
            />
            <Typography
              variant="h6"
              sx={{ fontWeight: "bold", mb: SPACING.xs }}
            >
              Facebook
            </Typography>
            <Typography variant="bodySm" sx={{ color: "text.secondary" }}>
              {t("platforms.facebook.description")}
            </Typography>
          </Box>

          <Button
            variant="outlined"
            sx={{ mt: 3 }}
            onClick={openFacebookOAuthPopup}
            fullWidth
          >
            {t("platforms.facebook.buttonText")}
          </Button>
        </Box>
      </Card>
    </Grid>
  );
};
